import { StanFilterConfig } from '@/components/core-components/StanFilters/types';

export const AFFILIATE_PAGE_SIZE = 10;
export const EXPORT_PER_PAGE = 1000;

export const CSV_FIELDS = {
    Username: {
        field: 'username',
        callback: (value: string) => `"${value}"`,
    },
    'Full Name': {
        field: 'full_name',
        callback: (value: string) => `"${value}"`,
    },
    Email: 'email',
    'Total Purchases': 'total_sales',
    'Total Revenue': 'total_earnings',
    'Refunds / Disputes': 'total_refunded_or_disputed',
    'Reseller Status': 'resell_status',
};

export const CSV_FILENAME = 'Your Stan Affiliates.csv';

/**
 * Filter configuration for the affiliate analytics table
 */
export const AFFILIATE_FILTERS: StanFilterConfig[] = [
    // TODO: Add username filter back in when backend works -> currently broken
    // {
    //     id: 'affiliate-username',
    //     label: 'Username',
    //     type: 'text',
    // },
    {
        id: 'affiliate-name',
        label: 'Name',
        type: 'text',
    },
    {
        id: 'affiliate-eid',
        label: 'Email',
        type: 'text',
    },
    {
        id: 'affiliate-status',
        label: 'Status',
        type: 'select',
        customDropdownReduce: 'value',
        customDropdownOptions: [
            { label: 'Active', value: 'active' },
            { label: 'Revoked', value: 'deleted' },
        ],
    },
    {
        id: 'affiliate-purchase-date',
        label: 'Purchase Date',
        type: 'date',
    },
    {
        id: 'affiliate-purchases',
        label: 'Purchases',
        type: 'number',
    },
    {
        id: 'affiliate-revenue',
        label: 'Revenue',
        type: 'number',
    },
    {
        id: 'affiliate-refunds',
        label: 'Chargebacks',
        type: 'number',
    },
];
